/**
 * Version Information
 *
 * APP_VERSION is auto-bumped by the .husky/pre-push hook on every push to
 * main when the pending commit range does not already touch this file.
 * To override (minor/major bump), edit and commit before pushing — the
 * hook will see your bump in the range and skip its own.
 */

export const APP_VERSION = '1.5.365';

export default APP_VERSION;
